export default "__VITE_ASSET__CgpQ7vRa__"